import styled from '@emotion/styled';
import Link from 'next/link';
import React from 'react';
import { breakpoints } from '../../../../utils/styleguide';
import Icon from '../../Icon';
import Typography from '../../text/Typography';
import HeaderWrapper from './HeaderWrapper';
import NavBarContainer from './NavBarContainer';

export const NAV_BAR_INITIATOR = 'nav bar';

type NavBarProps = {
  initiallyTransparent?: boolean;
};

const NavBlock = styled.div`
  pointer-events: auto;
`;

const GoHomeLink = styled.a`
  pointer-events: auto;
  display: flex;
  text-decoration: none;
  align-items: center;
`;

const PoweredByText = styled(Typography)`
  font-size: 14px;
  margin-right: 8px;
  ${breakpoints.tablet} {
    font-size: 10px;
  }
  ${breakpoints.desktop} {
    font-size: 12px;
  }
  transition: color 0.3s ease;
  ${({ color }: { color: string }) => `color: ${color};`}
`;

const WordmarkIcon = styled(Icon)`
  path {
    transition: fill 0.3s ease;
    ${({ currentcolor }: { currentcolor: string }) => `fill: ${currentcolor};`}
  }
  width: 110px;
  ${breakpoints.tablet} {
    width: 80px;
  }
  ${breakpoints.desktop} {
    width: 120px;
  }
`;

const PoweredByNavBar = ({ initiallyTransparent }: NavBarProps) => {
  return (
    <HeaderWrapper initiallyTransparent={initiallyTransparent}>
      {({ textColor }) => (
        <NavBarContainer>
          <NavBlock>
            <Link href="/" passHref>
              <GoHomeLink aria-label="go-home">
                <PoweredByText useBuiltInMargins variant="smallTextBold" color={textColor}>
                  Powered by{' '}
                </PoweredByText>
                <WordmarkIcon currentcolor={textColor} name={'milkywire-wordmark'} size="40" />
              </GoHomeLink>
            </Link>
          </NavBlock>
        </NavBarContainer>
      )}
    </HeaderWrapper>
  );
};

export default PoweredByNavBar;
